import './BrandMark.css'

/**
 * Stella brand mark: the real "s." app icon (the S glyph from
 * apps/frontend/src/assets/icons + the blue dot) beside the product label. The
 * glyph uses currentColor so it tracks the header ink across light/dark; the dot
 * is the fixed brand blue.
 */
export function BrandMark({
  subtitle = 'Skin profile',
}: {
  subtitle?: string
}) {
  return (
    <div className='brand'>
      <svg
        className='brand__mark'
        viewBox='0 0 720 560'
        role='img'
        aria-label='Stella'
      >
        <path
          d='M340.185 179.054C340.185 171.745 337.956 163.828 333.496 155.302C329.037 146.775 322.666 139.163 314.385 132.463C306.74 125.155 296.866 119.369 284.762 115.106C273.295 110.234 260.235 107.798 245.583 107.798C233.479 107.798 221.694 109.32 210.227 112.365C199.397 115.411 189.841 119.674 181.56 125.155C173.278 130.027 166.589 136.117 161.492 143.426C156.396 150.734 153.848 158.651 153.848 167.178C153.848 179.358 157.989 187.885 166.27 192.757C175.189 197.02 186.656 201.283 200.671 205.546L319.163 234.78C342.096 240.261 363.756 246.96 384.142 254.878C405.165 262.795 423.321 272.844 438.61 285.024C453.899 297.205 466.003 312.126 474.922 329.788C483.84 346.841 488.3 367.852 488.3 392.822C488.3 420.228 481.611 444.285 468.233 464.992C455.492 485.699 437.973 503.36 415.676 517.977C393.379 531.985 367.26 542.338 337.319 549.037C307.377 556.346 275.206 560 240.805 560C207.042 560 175.508 555.432 146.203 546.297C116.899 537.77 91.4169 525.59 69.7571 509.755C48.0974 493.921 30.897 475.041 18.156 453.116C6.05199 431.191 0 407.134 0 380.946H130.914C130.914 389.472 133.781 397.999 139.514 406.525C145.885 414.443 153.848 421.751 163.404 428.45C173.596 435.149 185.382 440.631 198.76 444.894C212.138 449.157 226.153 451.289 240.805 451.289C270.747 451.289 296.229 446.416 317.251 436.672C338.274 426.319 348.786 411.702 348.786 392.822C348.786 380.642 343.689 371.811 333.496 366.329C323.94 360.848 309.607 355.976 290.495 351.713L172.959 323.393C151.3 317.912 130.596 310.908 110.847 302.382C91.7354 293.855 74.8535 283.197 60.2013 270.408C45.5492 257.618 33.7637 242.697 24.845 225.644C16.5633 208.592 12.4225 189.103 12.4225 167.178C12.4225 139.772 18.4745 115.715 30.5785 95.0081C43.3195 74.3012 60.2013 56.944 81.224 42.9364C102.247 28.9288 126.773 18.2708 154.803 10.9624C183.471 3.65415 213.731 0 245.583 0C277.436 0 307.059 4.87221 334.452 14.6166C361.845 23.752 385.416 36.5416 405.165 52.9853C425.55 68.82 441.477 87.6998 452.943 109.625C464.41 130.941 470.144 154.084 470.144 179.054H340.185Z'
          fill='currentColor'
        />
        <circle cx='632' cy='476' r='76' fill='#1886d6' />
      </svg>
      <span className='brand__text'>
        <span className='brand__name'>Stella</span>
        <span className='brand__sub'>{subtitle}</span>
      </span>
    </div>
  )
}
